import axios from 'axios';

import apiConstants from './constants/api-constants';
import Helpers from '../common/helpers';

class CampaignsApi {
  static getCampaigns() {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.get, apiConstants.campaigns_routes.get_campaigns);

    return axios(request);
  }

  static addCampaign(data) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.post, apiConstants.campaigns_routes.add_campaign, data);

    return axios(request);
  }

  static editCampaign(data) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.post, apiConstants.campaigns_routes.edit_campaign, data);

    return axios(request);
  }

  static requestInstallLink(user_name, email) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.post, apiConstants.campaigns_routes.request_install_link, { user_name, email });

    return axios(request);
  }
}

export default CampaignsApi;



// WEBPACK FOOTER //
// ./src/api/campaigns-api.js